import { Button, Modal } from 'antd';

const BudgetSyncModal = ({ open, onOk, onCancel }) => {
  return (
    <Modal
      title="Transakcija je povezana s proračunom projekta"
      open={open}
      onCancel={onCancel}
      footer={[
        <Button key="cancel" onClick={onCancel}>Prekliči</Button>,
        <Button key="ok" type="primary" onClick={() => onOk('current_version')}>Potrdi</Button>,
      ]}
    >
      <p>Spremembe bodo shranjene <b>samo na transakciji</b>. Proračun projekta <b>ne bo posodobljen</b>.</p>
    </Modal>
  );
};

export default BudgetSyncModal;
